import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CsPage, NavController } from 'providers/nav-controller';
import { AlertController, AlertButtonRole } from 'providers/alert-controller';
import { AuthService } from 'services/auth.service';
import { FoodDbService } from 'services/food-db.service';
import { UserDb } from 'services/user-db.service';
import { untranslatedString } from 'models/translated-string';
import { IAdminConfigPage } from 'pages/admin-config/admin-config-interface';
import { IAdminTextListPage } from 'pages/admin-text-list/admin-text-list-interface';
import { IAdminExerciseListPage } from 'pages/admin-exercise-list/admin-exercise-list-interface';
import { IAdminExerciseSlotListPage } from 'pages/admin-exercise-slot-list/admin-exercise-slot-list-interface';
import { IAdminUserSearchPage } from 'pages/admin-user-search/admin-user-search-interface';
import { IAdminKeygenPage } from 'pages/admin-keygen/admin-keygen-interface';
import { IAdminImpersonatedUserPage } from 'pages/admin-impersonated-user/admin-impersonated-user-interface';

@Component({
    selector: 'page-admin-root',
    templateUrl: 'admin-root.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminRootPage extends CsPage<{}> {
  // Page interfaces for template navigation
  IAdminConfigPage = IAdminConfigPage;
  IAdminTextListPage = IAdminTextListPage;
  IAdminExerciseListPage = IAdminExerciseListPage;
  IAdminExerciseSlotListPage = IAdminExerciseSlotListPage;
  IAdminUserSearchPage = IAdminUserSearchPage;
  IAdminKeygenPage = IAdminKeygenPage;
  IAdminImpersonatedUserPage = IAdminImpersonatedUserPage;

  constructor(
    public navCtrl: NavController,
    protected auth: AuthService,
    private foodService: FoodDbService,
    private alertCtrl: AlertController,
    private userDb: UserDb,
  ) {
    super();
  }

  // read through UserDb, which reports a damaged or unreadable value once per page load (#5191)
  get isImpersonating(): boolean {
    return this.userDb.isImpersonating();
  }

  async publishUnpublishedFood() {
    await this.alertCtrl.showAlertAsync({
      message: untranslatedString('We will now publish unpublished food in the background.'),
      buttons: [{ text: untranslatedString('Ok'), role: AlertButtonRole.Primary }],
    });
    await this.foodService.tryPublishUnpublishedFoodsAsync(true);
  }
}
